export default __webpack_public_path__ + "static/media/02.0d5aa0d8.png";